import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { autocompleter, AUTOCOMPLETER_STATE_SLICE_KEY } from '../base-autocomplete/state/autocompleter.reducer';
import { BaseAutocompleteModule } from '../base-autocomplete/base-autocomplete.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { AppendToBodyModule } from 'NewAngular/features/directives/append-to-body/append-to-body.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class MultiItemAutocompleteModule {
}
MultiItemAutocompleteModule.ɵfac = function MultiItemAutocompleteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultiItemAutocompleteModule)(); };
MultiItemAutocompleteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MultiItemAutocompleteModule });
MultiItemAutocompleteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AppendToBodyModule,
        BaseAutocompleteModule,
        CommonModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        StoreModule.forFeature(AUTOCOMPLETER_STATE_SLICE_KEY, autocompleter),
        TooltipModule] });
